import React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';
import { createBasicColorSet, cssSpacing, screenMdMax, } from '@spotify-internal/encore-web';
import { ButtonPrimaryLink, Grid, SectionHeader, TWO_COLUMN_MAX_WIDTH, ImageLink, ONE_COLUMN_MAX_WIDTH, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
const TRACK_CAT = 'module-pageBreaker';
const PageBreaker = styled(Grid) `
  padding-block: ${cssSpacing('looser-4')};
  gap: ${cssSpacing('looser-3')};

  .text {
    grid-column: 1 / 9;
    @media (max-width: ${screenMdMax}) {
      grid-column: ${({ appBadges }) => (appBadges ? '1 / 8' : '1 / 9')};
    }

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column: 1 / -1;
    }
  }
  .cta {
    grid-column: 9/ 13;
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column: 1 / -1;
    }
    @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
      justify-content: center;
    }
  }
  .app-links {
    display: flex;
    grid-column: 9/ 13;
    @media (max-width: ${screenMdMax}) {
      grid-column: 8 / 13;
    }
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column: 1 / -1;
    }
  }
`;
const CTAContainer = styled.div `
  max-width: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${cssSpacing('looser-2')};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    justify-content: flex-start;
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    gap: ${cssSpacing('base')};
  }
`;
const getPageBreakerVersion = (moduleVersion, ctaButton, colors, appStoreLinks) => {
    switch (moduleVersion) {
        case 'Call to Action':
            if (get(ctaButton, 'ctaText.length') > 0 &&
                get(ctaButton, 'ctaLink.length') > 0) {
                return (React.createElement(CTAContainer, { className: "cta" },
                    React.createElement(ButtonPrimaryLink, { label: ctaButton.ctaText, href: ctaButton.ctaLink, openInNewTab: ctaButton.openInNewTab, trackingCategory: TRACK_CAT, trackingLabel: `CTA Link - ${ctaButton.title}`, UNSAFE_colorSet: createBasicColorSet(colors.textColor, colors.backgroundColor) })));
            }
            return React.createElement(React.Fragment, null);
        case 'App Stores':
            if (appStoreLinks) {
                return (React.createElement(CTAContainer, { className: "app-links" }, appStoreLinks.map(appStoreLink => {
                    const link = {
                        ...appStoreLink,
                        link: { ...appStoreLink.link, trackingCategory: TRACK_CAT },
                    };
                    return React.createElement(ImageLink, { ...link });
                })));
            }
            return React.createElement(React.Fragment, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const PageBreakerModule = React.forwardRef(({ headline = '', subtext = '', ctaButton = {
    ctaText: '',
    ctaLink: '',
    title: '',
}, appStoreLinks, moduleVersion = 'Call to Action', colors, }, ref) => {
    if (!headline) {
        return null;
    }
    return (React.createElement(ColorSetWrapper, { colors: colors },
        React.createElement(PageBreaker, { ref: ref, appBadges: moduleVersion === 'App Stores' },
            headline && (React.createElement("div", { className: "text" },
                React.createElement(SectionHeader, { body: subtext, heading: headline }))),
            getPageBreakerVersion(moduleVersion, ctaButton, colors, appStoreLinks))));
});
